import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  MessageBarActions,
  Button,
} from '@fluentui/react-components';

/**
 * Shared error primitive (spec §4.6): Fluent `MessageBar intent="error"`
 * with a retry action. Replaces the crimson text, the `MetricCard
 * label="Error"` card, the bespoke dashed-border error cards, and the
 * silent failure on Branch where a failed request left the skeleton in
 * place forever.
 */
export interface ErrorStateProps {
  title?: string;
  message?: string | null;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export function ErrorState({
  title = 'Something went wrong',
  message,
  onRetry,
  retryLabel = 'Try again',
  className,
}: ErrorStateProps) {
  return (
    <MessageBar intent="error" className={className}>
      <MessageBarBody>
        <MessageBarTitle>{title}</MessageBarTitle>
        {message}
      </MessageBarBody>
      {onRetry && (
        <MessageBarActions>
          <Button appearance="secondary" size="small" onClick={onRetry}>
            {retryLabel}
          </Button>
        </MessageBarActions>
      )}
    </MessageBar>
  );
}
